<template>
  <nav class="px-2 bg-white border-gray-200  ">
    <div class="container flex flex-wrap items-center justify-between mx-auto">
      <div
        class="
      text-sm
      font-bold
      leading-relaxed
      inline-block
      mr-4
      py-2
      whitespace-nowrap
       cursor-pointer
    "
        @click="back"
      >
        <i class="fas fa-arrow-left" />
        Retour à la liste
      </div>


      <button
        data-collapse-toggle="navbar-dropdown"
        type="button"
        class="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200   "
        aria-controls="navbar-dropdown"
        aria-expanded="false"
      >
        <span class="sr-only">Open main menu</span>
        <svg
          class="w-6 h-6"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
      <div
        id="navbar-dropdown"
        class="hidden w-full md:block md:w-auto"
      >
        <ul
          class="flex flex-col p-4 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-white"
        >
          <li>
            <a
              href="#"
              class="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0"
              aria-current="page"
            >Home</a>
          </li>
          <li>
            <button
              id="dropdownNavbarLink"
              data-dropdown-toggle="dropdownNavbar"
              class="flex items-center justify-between w-full py-2 pl-3 pr-4 font-medium text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 md:w-auto      "
            >
              Dropdown
              <svg
                class="w-5 h-5 ml-1"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
            <!-- Dropdown menu -->
            <div
              id="dropdownNavbar"
              class="z-10 hidden font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-44  "
            >
              <ul
                class="py-2 text-sm text-gray-700 "
                aria-labelledby="dropdownLargeButton"
              >
                <li>
                  <a
                    href="#"
                    class="block px-4 py-2 hover:bg-gray-100 "
                  >Dashboard</a>
                </li>
                <li>
                  <a
                    href="#"
                    class="block px-4 py-2 hover:bg-gray-100 "
                  >Settings</a>
                </li>
                <li>
                  <a
                    href="#"
                    class="block px-4 py-2 hover:bg-gray-100 "
                  >Earnings</a>
                </li>
              </ul>
              <div class="py-1">
                <a
                  href="#"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100  "
                >Sign
                  out</a>
              </div>
            </div>
          </li>
          <li>
            <a
              href="#"
              class="block py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0"
            >Services</a>
          </li>
          <li>
            <a
              href="#"
              class="block py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0"
            >Pricing</a>
          </li>
          <li>
            <a
              href="#"
              class="block py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0"
            >Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>



  <div class="p-4 sm:ml-64">
    <div class="p-4 border-2 border-gray-200 border-dashed rounded-lg  mt-14">
      <div class="grid grid-cols-3 gap-4 mb-4">
        <div class="flex items-center justify-center h-24 rounded bg-gray-50 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center h-24 rounded bg-gray-50 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center h-24 rounded bg-gray-50 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
      </div>
      <div class="flex items-center justify-center h-48 mb-4 rounded bg-gray-50 ">
        <p class="text-2xl text-gray-400 ">
          +
        </p>
      </div>
      <div class="grid grid-cols-2 gap-4 mb-4">
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
      </div>
      <div class="flex items-center justify-center h-48 mb-4 rounded bg-gray-50 ">
        <p class="text-2xl text-gray-400 ">
          +
        </p>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 ">
          <p class="text-2xl text-gray-400 ">
            +
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PageEditorViewBody',
    props: {
     
    },
    async mounted() {
    
    },
    methods: {
      back: function()
      {
        this.$router.push({ path: '/admin/views/scan-templates' })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>